import type { QuoteBuilderStateType } from '@ui/features/quote-builder/types/state';

import { buildElementId, type BuildElementIdParams } from './element-id';

export function setRawFieldValue(
  state: QuoteBuilderStateType,
  elementIdParams: BuildElementIdParams,
  value: string,
) {
  state.rawFieldValues[buildElementId(elementIdParams)] = value;
}

export function setRawFieldValues(
  state: QuoteBuilderStateType,
  elementIdParams: (BuildElementIdParams & { value: string })[],
) {
  for (const entry of elementIdParams) {
    setRawFieldValue(state, entry, entry.value);
  }
}

export function clearRawFieldValue(
  state: QuoteBuilderStateType,
  elementIdParams: BuildElementIdParams,
) {
  delete state.rawFieldValues[buildElementId(elementIdParams)];
}

export function clearRawFieldValues(
  state: QuoteBuilderStateType,
  elementIdParams: BuildElementIdParams[],
) {
  for (const entry of elementIdParams) {
    clearRawFieldValue(state, entry);
  }
}
